// U9b — Scholars preferencing validation (pure). Duplicated per-repo (NFR Q5=A / P7); the staff app
// keeps its own copy of any shared logic. Rules (BR-PR1/PR2/PR5):
//  - ranks 1–3 are REQUIRED, ranks 4–8 are OPTIONAL
//  - no duplicate program across ranks
//  - each rank maps to a distinct program

export const REQUIRED_RANKS = [1, 2, 3];
export const MAX_RANK = 6;

/**
 * Validate a set of ranked preferences.
 * @param {{rank:number, programId:string}[]} ranks
 * @returns {{ valid: boolean, errors: string[] }}
 */
export function validatePreferences(ranks = []) {
    const errors = [];
    const byRank = new Map();

    for (const entry of ranks) {
        const rank = Number(entry?.rank);
        const programId = entry?.programId;
        if (!Number.isInteger(rank) || rank < 1 || rank > MAX_RANK) {
            errors.push(`Invalid rank: ${entry?.rank}`);
            continue;
        }
        if (byRank.has(rank)) {
            errors.push(`Duplicate rank: ${rank}`);
            continue;
        }
        byRank.set(rank, programId);
    }

    // Required ranks 1–3 must be present and non-empty.
    for (const r of REQUIRED_RANKS) {
        const programId = byRank.get(r);
        if (!programId) { errors.push(`Rank ${r} is required`); }
    }

    // No duplicate program across the provided (non-empty) ranks.
    const programs = [...byRank.values()].filter(Boolean);
    const uniquePrograms = new Set(programs);
    if (uniquePrograms.size !== programs.length) {
        errors.push('A program may not be selected for more than one rank');
    }

    // no gaps between choices: the present ranks must be a contiguous run 1..N
    const presentRanks = [...byRank.keys()].sort((a, b) => a - b);
    if (presentRanks.length > 0) {
    const maxRank = presentRanks[presentRanks.length - 1];
    if (maxRank !== presentRanks.length) {
        errors.push('Remove the empty ranking between your choices');
    }
}

    return { valid: errors.length === 0, errors };


}

/** True when required ranks are valid and there are no duplicates — used to gate submit (BR-PR5). */
export function canSubmitPreferences(ranks = []) {
    return validatePreferences(ranks).valid;
}
